import React from 'react';
import { cn } from '../../lib/utils';
import { useDropdownContext } from './Dropdown';

interface DropdownHeaderProps {
  children: React.ReactNode;
  className?: string;
  actions?: React.ReactNode;
}

export function DropdownHeader({ children, className = '', actions }: DropdownHeaderProps) {
  const { isMobile } = useDropdownContext();

  return (
    <div
      className={cn(
        'flex items-center justify-between',
        'border-b border-gray-200 bg-gray-50',
        isMobile ? 'px-4 py-3' : 'px-3 py-2.5',
        className
      )}
    >
      <h3 className="font-medium text-gray-700 truncate">{children}</h3>

      {actions && <div className="flex-shrink-0 flex items-center ml-2">{actions}</div>}
    </div>
  );
}
